import { render, staticRenderFns } from "./ProfitLoss.vue?vue&type=template&id=4b1c7360&scoped=true&"
import script from "./ProfitLoss.vue?vue&type=script&lang=js&"
export * from "./ProfitLoss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c7360",
  null
  
)

export default component.exports